import _wrapNativeSuper from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
import _defineProperty from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _asyncToGenerator from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _assertThisInitialized from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _set from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/set";
import _get from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/get";
import _inherits from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "/opt/build/repo/gatsby/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ei = Object.defineProperty;

var ti = function ti(i, t, e) {
  return t in i ? ei(i, t, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: e
  }) : i[t] = e;
};

var f = function f(i, t, e) {
  return ti(i, typeof t != "symbol" ? t + "" : t, e), e;
},
    nt = function nt(i, t, e) {
  if (!t.has(i)) throw TypeError("Cannot " + e);
};

var r = function r(i, t, e) {
  return nt(i, t, "read from private field"), e ? e.call(i) : t.get(i);
},
    d = function d(i, t, e) {
  if (t.has(i)) throw TypeError("Cannot add the same private member more than once");
  t instanceof WeakSet ? t.add(i) : t.set(i, e);
},
    c = function c(i, t, e, n) {
  return nt(i, t, "write to private field"), n ? n.call(i, e) : t.set(i, e), e;
};

var T = function T(i, t, e) {
  return nt(i, t, "access private method"), e;
};

var de = /*#__PURE__*/function () {
  function de() {
    _classCallCheck(this, de);
  }

  _createClass(de, [{
    key: "addEventListener",
    value: function addEventListener() {}
  }, {
    key: "removeEventListener",
    value: function removeEventListener() {}
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(t) {
      return !0;
    }
  }]);

  return de;
}();

if (typeof DocumentFragment == "undefined") {
  var i = /*#__PURE__*/function (_de) {
    _inherits(i, _de);

    var _super = _createSuper(i);

    function i() {
      _classCallCheck(this, i);

      return _super.apply(this, arguments);
    }

    return i;
  }(de);

  globalThis.DocumentFragment = i;
}

var Pe = /*#__PURE__*/function (_de2) {
  _inherits(Pe, _de2);

  var _super2 = _createSuper(Pe);

  function Pe() {
    _classCallCheck(this, Pe);

    return _super2.apply(this, arguments);
  }

  return Pe;
}(de),
    at = /*#__PURE__*/function (_de3) {
  _inherits(at, _de3);

  var _super3 = _createSuper(at);

  function at() {
    _classCallCheck(this, at);

    return _super3.apply(this, arguments);
  }

  return at;
}(de),
    ii = {
  get: function get(i) {},
  define: function define(i, t, e) {},
  upgrade: function upgrade(i) {},
  whenDefined: function whenDefined(i) {
    return Promise.resolve(Pe);
  }
},
    Le,
    ot = /*#__PURE__*/function () {
  function ot(t) {
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, ot);

    d(this, Le, void 0);
    c(this, Le, e == null ? void 0 : e.detail);
  }

  _createClass(ot, [{
    key: "detail",
    get: function get() {
      return r(this, Le);
    }
  }, {
    key: "initCustomEvent",
    value: function initCustomEvent() {}
  }]);

  return ot;
}();

Le = new WeakMap();

function ri(i, t) {
  return new Pe();
}

var Lt = {
  document: {
    createElement: ri
  },
  DocumentFragment: DocumentFragment,
  customElements: ii,
  CustomEvent: ot,
  EventTarget: de,
  HTMLElement: Pe,
  HTMLVideoElement: at
},
    Ot = typeof window == "undefined" || typeof globalThis.customElements == "undefined",
    Oe = Ot ? Lt : globalThis,
    Ii = Ot ? Lt.document : globalThis.document;
import { initialize as ui, teardown as hi, generatePlayerInitTime as li, PlaybackTypes as it, toMuxVideoURL as fi, MediaError as Xr, getError as mi, CmcdTypeValues as Zt, addCuePoints as pi, getCuePoints as gi, getActiveCuePoint as Ei, getStartDate as vi, getCurrentPdt as yi, getStreamType as Ti, getTargetLiveWindow as bi, getLiveEdgeStart as ki, getSeekable as Ai, getEnded as Si } from "@mux/playback-core";

var si = function si() {
  try {
    return "0.17.0";
  } catch (_unused) {}

  return "UNKNOWN";
},
    ni = si(),
    Ct = function Ct() {
  return ni;
};

var It = function It(i) {
  var _t2, e, n, a, m, wt, y, We, L, N, M, Ke, ne, $e, qe, Mt, Ue, xt, ae, dt, l, k, S, g, v, P, I, Ce, Be, _t, Ae, ct, Ye, Dt, Se, ut, je, Nt, Re, ht;

  return _t2 = /*#__PURE__*/function (_i) {
    _inherits(t, _i);

    var _super4 = _createSuper(t);

    function t() {
      var _this;

      _classCallCheck(this, t);

      _this = _super4.call(this);
      d(_assertThisInitialized(_this), I);
      d(_assertThisInitialized(_this), Be);
      d(_assertThisInitialized(_this), Ae);
      d(_assertThisInitialized(_this), Ye);
      d(_assertThisInitialized(_this), Se);
      d(_assertThisInitialized(_this), je);
      d(_assertThisInitialized(_this), Re);
      f(_assertThisInitialized(_this), "castEnabled", !1);
      d(_assertThisInitialized(_this), l, {
        paused: !1
      });
      d(_assertThisInitialized(_this), k, void 0);
      d(_assertThisInitialized(_this), S, {});
      d(_assertThisInitialized(_this), g, void 0);
      d(_assertThisInitialized(_this), v, void 0);
      d(_assertThisInitialized(_this), P, void 0);
      _t2.instances.add(_assertThisInitialized(_this)), T(_assertThisInitialized(_this), Se, ut).call(_assertThisInitialized(_this));
      return _this;
    }

    _createClass(t, [{
      key: "castPlayer",
      get: function get() {
        if (_t2.castElement === this) return r(this, k);
      }
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(s) {
        if (!!this.castPlayer) switch (s) {
          case "cast-stream-type":
          case "cast-src":
            this.load();
            break;
        }
      }
    }, {
      key: "requestCast",
      value: function () {
        var _requestCast = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var _this2 = this;

          var s,
              h,
              _args = arguments;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  s = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
                  T(h = _t2, ae, dt).call(h, s), c(_t2, e, this), Object.entries(r(this, S)).forEach(function (_ref) {
                    var _ref2 = _slicedToArray(_ref, 2),
                        A = _ref2[0],
                        O = _ref2[1];

                    r(_this2, k).controller.addEventListener(A, O);
                  });
                  _context.prev = 2;
                  _context.next = 5;
                  return r(_t2, L, N).requestSession();

                case 5:
                  _context.next = 11;
                  break;

                case 7:
                  _context.prev = 7;
                  _context.t0 = _context["catch"](2);
                  c(_t2, e, void 0);
                  return _context.abrupt("return");

                case 11:
                  r(this, l).paused = _get(_getPrototypeOf(t.prototype), "paused", this), _get(_getPrototypeOf(t.prototype), "pause", this).call(this), this.muted = _get(_getPrototypeOf(t.prototype), "muted", this);
                  _context.prev = 12;
                  _context.next = 15;
                  return this.load();

                case 15:
                  _context.next = 20;
                  break;

                case 17:
                  _context.prev = 17;
                  _context.t1 = _context["catch"](12);
                  console.error(_context.t1);

                case 20:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this, [[2, 7], [12, 17]]);
        }));

        function requestCast() {
          return _requestCast.apply(this, arguments);
        }

        return requestCast;
      }()
    }, {
      key: "load",
      value: function () {
        var _load = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
          var D, Q, s, h, A, O, C;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (this.castPlayer) {
                    _context2.next = 2;
                    break;
                  }

                  return _context2.abrupt("return", _get(_getPrototypeOf(t.prototype), "load", this).call(this));

                case 2:
                  s = new chrome.cast.media.MediaInfo(this.castSrc, this.castContentType), h = _toConsumableArray(this.querySelectorAll("track")).filter(function (_ref3) {
                    var x = _ref3.kind,
                        w = _ref3.src;
                    return w && (x === "subtitles" || x === "captions");
                  }), A = [], O = 0;
                  h.length && (s.tracks = h.map(function (x) {
                    var w = ++O;
                    A.length === 0 && x.track.mode === "showing" && A.push(w);
                    var Z = new chrome.cast.media.Track(w, chrome.cast.media.TrackType.TEXT);
                    return Z.trackContentId = x.src, Z.trackContentType = "text/vtt", Z.subtype = x.kind === "captions" ? chrome.cast.media.TextTrackType.CAPTIONS : chrome.cast.media.TextTrackType.SUBTITLES, Z.name = x.label, Z.language = x.srclang, Z;
                  })), this.castStreamType === "live" ? s.streamType = chrome.cast.media.StreamType.LIVE : s.streamType = chrome.cast.media.StreamType.BUFFERED, s.metadata = new chrome.cast.media.GenericMediaMetadata(), s.metadata.title = this.title, s.metadata.images = [{
                    url: this.poster
                  }];
                  C = new chrome.cast.media.LoadRequest(s);
                  C.currentTime = (D = _get(_getPrototypeOf(t.prototype), "currentTime", this)) != null ? D : 0;
                  C.autoplay = !r(this, l).paused;
                  C.activeTrackIds = A;
                  _context2.next = 10;
                  return (Q = r(_t2, M, Ke)) == null ? void 0 : Q.loadMedia(C);

                case 10:
                  this.dispatchEvent(new Event("volumechange"));

                case 11:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this);
        }));

        function load() {
          return _load.apply(this, arguments);
        }

        return load;
      }()
    }, {
      key: "play",
      value: function play() {
        var s;

        if (this.castPlayer) {
          this.castPlayer.isPaused && ((s = this.castPlayer.controller) == null || s.playOrPause());
          return;
        }

        return _get(_getPrototypeOf(t.prototype), "play", this).call(this);
      }
    }, {
      key: "pause",
      value: function pause() {
        var s;

        if (this.castPlayer) {
          this.castPlayer.isPaused || (s = this.castPlayer.controller) == null || s.playOrPause();
          return;
        }

        _get(_getPrototypeOf(t.prototype), "pause", this).call(this);
      }
    }, {
      key: "castSrc",
      get: function get() {
        var s, h, A;
        return (A = (h = this.getAttribute("cast-src")) != null ? h : (s = this.querySelector("source")) == null ? void 0 : s.src) != null ? A : this.currentSrc;
      },
      set: function set(s) {
        this.castSrc != s && this.setAttribute("cast-src", "".concat(s));
      }
    }, {
      key: "castContentType",
      get: function get() {
        var s;
        return (s = this.getAttribute("cast-content-type")) != null ? s : void 0;
      },
      set: function set(s) {
        this.setAttribute("cast-content-type", "".concat(s));
      }
    }, {
      key: "castStreamType",
      get: function get() {
        var s, h;
        return (h = (s = this.getAttribute("cast-stream-type")) != null ? s : this.streamType) != null ? h : void 0;
      },
      set: function set(s) {
        this.setAttribute("cast-stream-type", "".concat(s));
      }
    }, {
      key: "readyState",
      get: function get() {
        if (this.castPlayer) switch (this.castPlayer.playerState) {
          case chrome.cast.media.PlayerState.IDLE:
            return 0;

          case chrome.cast.media.PlayerState.BUFFERING:
            return 2;

          default:
            return 3;
        }
        return _get(_getPrototypeOf(t.prototype), "readyState", this);
      }
    }, {
      key: "paused",
      get: function get() {
        return this.castPlayer ? this.castPlayer.isPaused : _get(_getPrototypeOf(t.prototype), "paused", this);
      }
    }, {
      key: "muted",
      get: function get() {
        var s;
        return this.castPlayer ? (s = this.castPlayer) == null ? void 0 : s.isMuted : _get(_getPrototypeOf(t.prototype), "muted", this);
      },
      set: function set(s) {
        var h;

        if (this.castPlayer) {
          (s && !this.castPlayer.isMuted || !s && this.castPlayer.isMuted) && ((h = this.castPlayer.controller) == null || h.muteOrUnmute());
          return;
        }

        _set(_getPrototypeOf(t.prototype), "muted", s, this, true);
      }
    }, {
      key: "volume",
      get: function get() {
        var s, h;
        return this.castPlayer ? (h = (s = this.castPlayer) == null ? void 0 : s.volumeLevel) != null ? h : 1 : _get(_getPrototypeOf(t.prototype), "volume", this);
      },
      set: function set(s) {
        var h;

        if (this.castPlayer) {
          this.castPlayer.volumeLevel = s, (h = this.castPlayer.controller) == null || h.setVolumeLevel();
          return;
        }

        _set(_getPrototypeOf(t.prototype), "volume", s, this, true);
      }
    }, {
      key: "duration",
      get: function get() {
        var s, h;
        return this.castPlayer && r(this, I, Ce) ? (h = (s = this.castPlayer) == null ? void 0 : s.duration) != null ? h : NaN : _get(_getPrototypeOf(t.prototype), "duration", this);
      }
    }, {
      key: "currentTime",
      get: function get() {
        var s, h;
        return this.castPlayer && r(this, I, Ce) ? (h = (s = this.castPlayer) == null ? void 0 : s.currentTime) != null ? h : 0 : _get(_getPrototypeOf(t.prototype), "currentTime", this);
      },
      set: function set(s) {
        var h;

        if (this.castPlayer) {
          this.castPlayer.currentTime = s, (h = this.castPlayer.controller) == null || h.seek();
          return;
        }

        _set(_getPrototypeOf(t.prototype), "currentTime", s, this, true);
      }
    }, {
      key: "onentercast",
      get: function get() {
        return r(this, g);
      },
      set: function set(s) {
        r(this, g) && (this.removeEventListener("entercast", r(this, g)), c(this, g, null)), typeof s == "function" && (c(this, g, s), this.addEventListener("entercast", s));
      }
    }, {
      key: "onleavecast",
      get: function get() {
        return r(this, v);
      },
      set: function set(s) {
        r(this, v) && (this.removeEventListener("leavecast", r(this, v)), c(this, v, null)), typeof s == "function" && (c(this, v, s), this.addEventListener("leavecast", s));
      }
    }, {
      key: "oncastchange",
      get: function get() {
        return r(this, P);
      },
      set: function set(s) {
        r(this, P) && (this.removeEventListener("castchange", r(this, P)), c(this, P, null)), typeof s == "function" && (c(this, P, s), this.addEventListener("castchange", s));
      }
    }], [{
      key: "castElement",
      get: function get() {
        return r(_t2, e);
      }
    }, {
      key: "castEnabled",
      get: function get() {
        return r(_t2, n);
      }
    }, {
      key: "castState",
      get: function get() {
        var s;
        return (s = r(_t2, L, N)) == null ? void 0 : s.getCastState();
      }
    }, {
      key: "exitCast",
      value: function () {
        var _exitCast = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.prev = 0;
                  _context3.next = 3;
                  return r(_t2, L, N).endCurrentSession(!0);

                case 3:
                  _context3.next = 9;
                  break;

                case 5:
                  _context3.prev = 5;
                  _context3.t0 = _context3["catch"](0);
                  console.error(_context3.t0);
                  return _context3.abrupt("return");

                case 9:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, null, [[0, 5]]);
        }));

        function exitCast() {
          return _exitCast.apply(this, arguments);
        }

        return exitCast;
      }()
    }]);

    return t;
  }(i), e = new WeakMap(), n = new WeakMap(), a = new WeakMap(), m = new WeakSet(), wt = function wt() {
    return typeof chrome != "undefined" && chrome.cast && chrome.cast.isAvailable;
  }, y = new WeakSet(), We = function We() {
    return typeof cast != "undefined" && cast.framework;
  }, L = new WeakSet(), N = function N() {
    if (r(_t2, y, We)) return cast.framework.CastContext.getInstance();
  }, M = new WeakSet(), Ke = function Ke() {
    var s;
    return (s = r(_t2, L, N)) == null ? void 0 : s.getCurrentSession();
  }, ne = new WeakSet(), $e = function $e() {
    var s;
    return (s = r(_t2, M, Ke)) == null ? void 0 : s.getSessionObj().media[0];
  }, qe = new WeakSet(), Mt = function Mt(s) {
    return new Promise(function (h, A) {
      r(_t2, ne, $e).editTracksInfo(s, h, A);
    });
  }, Ue = new WeakSet(), xt = function xt(s) {
    return new Promise(function (h, A) {
      r(_t2, ne, $e).getStatus(s, h, A);
    });
  }, ae = new WeakSet(), dt = function dt(s) {
    return r(_t2, L, N).setOptions(_objectSpread({
      receiverApplicationId: chrome.cast.media.DEFAULT_MEDIA_RECEIVER_APP_ID,
      autoJoinPolicy: chrome.cast.AutoJoinPolicy.ORIGIN_SCOPED,
      androidReceiverCompatible: !1,
      language: "en-US",
      resumeSavedSession: !0
    }, s));
  }, l = new WeakMap(), k = new WeakMap(), S = new WeakMap(), g = new WeakMap(), v = new WeakMap(), P = new WeakMap(), I = new WeakSet(), Ce = function Ce() {
    var s;
    return (s = this.castPlayer) == null ? void 0 : s.isMediaLoaded;
  }, Be = new WeakSet(), _t = function _t() {
    var _this3 = this;

    r(_t2, e) === this && (Object.entries(r(this, S)).forEach(function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
          s = _ref5[0],
          h = _ref5[1];

      r(_this3, k).controller.removeEventListener(s, h);
    }), c(_t2, e, void 0), this.muted = r(this, k).isMuted, this.currentTime = r(this, k).savedPlayerState.currentTime, r(this, k).savedPlayerState.isPaused === !1 && this.play());
  }, Ae = new WeakSet(), ct = function ct() {
    this.dispatchEvent(new CustomEvent("castchange", {
      detail: r(_t2, L, N).getCastState()
    }));
  }, Ye = new WeakSet(), Dt = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
      var _this4 = this;

      var h, A, s;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              s = cast.framework.SessionState.SESSION_RESUMED;

              if (!(r(_t2, L, N).getSessionState() === s && this.castSrc === ((h = r(_t2, ne, $e)) == null ? void 0 : h.media.contentId))) {
                _context4.next = 12;
                break;
              }

              c(_t2, e, this), Object.entries(r(this, S)).forEach(function (_ref7) {
                var _ref8 = _slicedToArray(_ref7, 2),
                    O = _ref8[0],
                    C = _ref8[1];

                r(_this4, k).controller.addEventListener(O, C);
              });
              _context4.prev = 3;
              _context4.next = 6;
              return T(A = _t2, Ue, xt).call(A, new chrome.cast.media.GetStatusRequest());

            case 6:
              _context4.next = 11;
              break;

            case 8:
              _context4.prev = 8;
              _context4.t0 = _context4["catch"](3);
              console.error(_context4.t0);

            case 11:
              r(this, S)[cast.framework.RemotePlayerEventType.IS_PAUSED_CHANGED](), r(this, S)[cast.framework.RemotePlayerEventType.PLAYER_STATE_CHANGED]();

            case 12:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, this, [[3, 8]]);
    }));

    return function Dt() {
      return _ref6.apply(this, arguments);
    };
  }(), Se = new WeakSet(), ut = function ut() {
    var _this5 = this,
        _c;

    var s;
    !r(_t2, y, We) || this.castEnabled || (this.castEnabled = !0, T(s = _t2, ae, dt).call(s), this.textTracks.addEventListener("change", T(this, Re, ht).bind(this)), T(this, Ae, ct).call(this), c(this, k, new cast.framework.RemotePlayer()), new cast.framework.RemotePlayerController(r(this, k)), c(this, S, (_c = {}, _defineProperty(_c, cast.framework.RemotePlayerEventType.IS_CONNECTED_CHANGED, function (_ref9) {
      var h = _ref9.value;
      h === !1 && T(_this5, Be, _t).call(_this5), _this5.dispatchEvent(new Event(h ? "entercast" : "leavecast"));
    }), _defineProperty(_c, cast.framework.RemotePlayerEventType.DURATION_CHANGED, function () {
      _this5.dispatchEvent(new Event("durationchange"));
    }), _defineProperty(_c, cast.framework.RemotePlayerEventType.VOLUME_LEVEL_CHANGED, function () {
      _this5.dispatchEvent(new Event("volumechange"));
    }), _defineProperty(_c, cast.framework.RemotePlayerEventType.IS_MUTED_CHANGED, function () {
      _this5.dispatchEvent(new Event("volumechange"));
    }), _defineProperty(_c, cast.framework.RemotePlayerEventType.CURRENT_TIME_CHANGED, function () {
      !r(_this5, I, Ce) || _this5.dispatchEvent(new Event("timeupdate"));
    }), _defineProperty(_c, cast.framework.RemotePlayerEventType.VIDEO_INFO_CHANGED, function () {
      _this5.dispatchEvent(new Event("resize"));
    }), _defineProperty(_c, cast.framework.RemotePlayerEventType.IS_PAUSED_CHANGED, function () {
      _this5.dispatchEvent(new Event(_this5.paused ? "pause" : "play"));
    }), _defineProperty(_c, cast.framework.RemotePlayerEventType.PLAYER_STATE_CHANGED, function () {
      var _chrome$cast$media$Pl;

      var h, A;
      ((h = _this5.castPlayer) == null ? void 0 : h.playerState) !== chrome.cast.media.PlayerState.PAUSED && _this5.dispatchEvent(new Event((_chrome$cast$media$Pl = {}, _defineProperty(_chrome$cast$media$Pl, chrome.cast.media.PlayerState.PLAYING, "playing"), _defineProperty(_chrome$cast$media$Pl, chrome.cast.media.PlayerState.BUFFERING, "waiting"), _defineProperty(_chrome$cast$media$Pl, chrome.cast.media.PlayerState.IDLE, "emptied"), _chrome$cast$media$Pl)[(A = _this5.castPlayer) == null ? void 0 : A.playerState]));
    }), _defineProperty(_c, cast.framework.RemotePlayerEventType.IS_MEDIA_LOADED_CHANGED, _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.t0 = !r(_this5, I, Ce);

              if (_context5.t0) {
                _context5.next = 5;
                break;
              }

              _context5.next = 4;
              return Promise.resolve();

            case 4:
              T(_this5, je, Nt).call(_this5);

            case 5:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))), _c)));
  }, je = new WeakSet(), Nt = function Nt() {
    T(this, Re, ht).call(this);
  }, Re = new WeakSet(), ht = /*#__PURE__*/function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
      var vt, yt, Tt, bt, kt, At, h, A, O, D, Q, x, w, R;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (this.castPlayer) {
                _context6.next = 2;
                break;
              }

              return _context6.abrupt("return");

            case 2:
              h = ((yt = (vt = r(this, k).mediaInfo) == null ? void 0 : vt.tracks) != null ? yt : []).filter(function (_ref12) {
                var R = _ref12.type;
                return R === chrome.cast.media.TrackType.TEXT;
              }), A = _toConsumableArray(this.textTracks).filter(function (_ref13) {
                var R = _ref13.kind;
                return R === "subtitles" || R === "captions";
              }), O = h.map(function (_ref14) {
                var R = _ref14.language,
                    He = _ref14.name,
                    st = _ref14.trackId;
                var Rt;

                var _ref15 = (Rt = A.find(function (Pt) {
                  return Pt.language === R && Pt.label === He;
                })) != null ? Rt : {},
                    St = _ref15.mode;

                return St ? {
                  mode: St,
                  trackId: st
                } : !1;
              }).filter(Boolean), D = O.filter(function (_ref16) {
                var R = _ref16.mode;
                return R !== "showing";
              }).map(function (_ref17) {
                var R = _ref17.trackId;
                return R;
              }), Q = O.find(function (_ref18) {
                var R = _ref18.mode;
                return R === "showing";
              }), x = (kt = (bt = (Tt = r(_t2, M, Ke)) == null ? void 0 : Tt.getSessionObj().media[0]) == null ? void 0 : bt.activeTrackIds) != null ? kt : [], w = x;

              if (!(x.length && (w = w.filter(function (R) {
                return !D.includes(R);
              })), Q != null && Q.trackId && (w = [].concat(_toConsumableArray(w), [Q.trackId])), w = _toConsumableArray(new Set(w)), !function (R, He) {
                return R.length === He.length && R.every(function (st) {
                  return He.includes(st);
                });
              }(x, w))) {
                _context6.next = 13;
                break;
              }

              _context6.prev = 4;
              R = new chrome.cast.media.EditTracksInfoRequest(w);
              _context6.next = 8;
              return T(At = _t2, qe, Mt).call(At, R);

            case 8:
              _context6.next = 13;
              break;

            case 10:
              _context6.prev = 10;
              _context6.t0 = _context6["catch"](4);
              console.error(_context6.t0);

            case 13:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, this, [[4, 10]]);
    }));

    return function ht() {
      return _ref11.apply(this, arguments);
    };
  }(), d(_t2, m), d(_t2, y), d(_t2, L), d(_t2, M), d(_t2, ne), d(_t2, qe), d(_t2, Ue), d(_t2, ae), f(_t2, "observedAttributes", ["cast-src", "cast-content-type", "cast-stream-type"]), f(_t2, "instances", new Set()), d(_t2, e, void 0), d(_t2, n, !1), f(_t2, "initCast", function () {
    var s;
    r(_t2, m, wt) ? r(_t2, y, We) ? r(s = _t2, a).call(s, chrome.cast.isAvailable) : customElements.whenDefined("google-cast-button").then(function () {
      var h;
      return r(h = _t2, a).call(h, chrome.cast.isAvailable);
    }) : globalThis.__onGCastApiAvailable = function () {
      customElements.whenDefined("google-cast-button").then(function () {
        var h;
        return r(h = _t2, a).call(h, chrome.cast.isAvailable);
      });
    };
  }), d(_t2, a, function (s) {
    if (s) {
      c(_t2, n, !0);
      var h = cast.framework.CastContextEventType.CAST_STATE_CHANGED;
      r(_t2, L, N).addEventListener(h, function (O) {
        _t2.instances.forEach(function (C) {
          var D;
          return T(D = C, Ae, ct).call(D, O);
        });
      });
      var A = cast.framework.CastContextEventType.SESSION_STATE_CHANGED;
      r(_t2, L, N).addEventListener(A, function (O) {
        _t2.instances.forEach(function (C) {
          var D;
          return T(D = C, Ye, Dt).call(D, O);
        });
      }), _t2.instances.forEach(function (O) {
        var C;
        return T(C = O, Se, ut).call(C);
      });
    }
  }), _t2;
},
    lt = globalThis.HTMLVideoElement ? It(HTMLVideoElement) : It(Object);

globalThis.customElements && !globalThis.customElements.get("castable-video") && (customElements.define("castable-video", lt, {
  extends: "video"
}), globalThis.CastableVideoElement = lt);
lt.initCast();
var pt = ["abort", "canplay", "canplaythrough", "durationchange", "emptied", "encrypted", "ended", "error", "loadeddata", "loadedmetadata", "loadstart", "pause", "play", "playing", "progress", "ratechange", "seeked", "seeking", "stalled", "suspend", "timeupdate", "volumechange", "waiting", "waitingforkey", "resize", "enterpictureinpicture", "leavepictureinpicture", "webkitbeginfullscreen", "webkitendfullscreen", "webkitpresentationmodechanged"],
    Vt,
    ft = (Vt = globalThis.document) == null ? void 0 : Vt.createElement("template");
ft && (ft.innerHTML = "\n    <style>\n      :host {\n        display: inline-block;\n        line-height: 0;\n      }\n\n      audio {\n        max-width: 100%;\n        max-height: 100%;\n        min-width: 100%;\n        min-height: 100%;\n      }\n    </style>\n    <slot></slot>\n  ");
var Ft,
    mt = (Ft = globalThis.document) == null ? void 0 : Ft.createElement("template");
mt && (mt.innerHTML = "\n    <style>\n      :host {\n        display: inline-block;\n        line-height: 0;\n      }\n\n      video {\n        max-width: 100%;\n        max-height: 100%;\n        min-width: 100%;\n        min-height: 100%;\n        object-fit: var(--media-object-fit, contain);\n        object-position: var(--media-object-position, 50% 50%);\n      }\n\n      video::-webkit-media-text-track-container {\n        transform: var(--media-webkit-text-track-transform);\n        transition: var(--media-webkit-text-track-transition);\n      }\n    </style>\n    <slot></slot>\n  ");

var ze = function ze(i, _ref19) {
  var t = _ref19.tag,
      e = _ref19.is;

  var m, _E, y, b, qt, ke, M, q, ce, Fe, Gt, Ge, Ut;

  var n = (m = globalThis.document) == null ? void 0 : m.createElement(t, {
    is: e
  }),
      a = n ? ai(n) : [];
  return _E = /*#__PURE__*/function (_i2) {
    _inherits(E, _i2);

    var _super5 = _createSuper(E);

    function E() {
      var _this6;

      _classCallCheck(this, E);

      _this6 = _super5.call(this);
      d(_assertThisInitialized(_this6), q);
      d(_assertThisInitialized(_this6), Fe);
      d(_assertThisInitialized(_this6), Ge);
      d(_assertThisInitialized(_this6), ke, void 0);
      d(_assertThisInitialized(_this6), M, void 0);
      _this6.shadowRoot || (_this6.attachShadow({
        mode: "open"
      }), _this6.shadowRoot.append(_this6.constructor.template.content.cloneNode(!0)));
      return _this6;
    }

    _createClass(E, [{
      key: "nativeEl",
      get: function get() {
        var p, l;
        return (l = (p = r(this, M)) != null ? p : this.shadowRoot.querySelector(t)) != null ? l : this.querySelector(t);
      },
      set: function set(p) {
        c(this, M, p);
      }
    }, {
      key: "defaultMuted",
      get: function get() {
        return this.hasAttribute("muted");
      },
      set: function set(p) {
        this.toggleAttribute("muted", Boolean(p));
      }
    }, {
      key: "src",
      get: function get() {
        return this.getAttribute("src");
      },
      set: function set(p) {
        this.setAttribute("src", "".concat(p));
      }
    }, {
      key: "preload",
      get: function get() {
        var p, l;
        return (l = this.getAttribute("preload")) != null ? l : (p = this.nativeEl) == null ? void 0 : p.preload;
      },
      set: function set(p) {
        this.setAttribute("preload", "".concat(p));
      }
    }, {
      key: "attributeChangedCallback",
      value: function attributeChangedCallback(p, l, k) {
        T(this, q, ce).call(this), T(this, Ge, Ut).call(this, p, l, k);
      }
    }, {
      key: "connectedCallback",
      value: function connectedCallback() {
        T(this, q, ce).call(this);
      }
    }], [{
      key: "observedAttributes",
      get: function get() {
        var l, k, S;
        return T(l = _E, b, qt).call(l), [].concat(_toConsumableArray((S = (k = n == null ? void 0 : n.constructor) == null ? void 0 : k.observedAttributes) != null ? S : []), ["autopictureinpicture", "disablepictureinpicture", "disableremoteplayback", "autoplay", "controls", "controlslist", "crossorigin", "loop", "muted", "playsinline", "poster", "preload", "src"]);
      }
    }]);

    return E;
  }(i), y = new WeakMap(), b = new WeakSet(), qt = function qt() {
    var _this7 = this;

    if (r(this, y)) return;
    c(this, y, !0);
    var p = new Set(this.observedAttributes);
    p.delete("muted");

    var _iterator = _createForOfIteratorHelper(a),
        _step;

    try {
      var _loop = function _loop() {
        var l = _step.value;
        if (l in _this7.prototype) return "continue";
        if (typeof n[l] == "function") _this7.prototype[l] = function () {
          var _this8 = this;

          for (var _len = arguments.length, S = new Array(_len), _key = 0; _key < _len; _key++) {
            S[_key] = arguments[_key];
          }

          return T(this, q, ce).call(this), function () {
            return _this8.call ? _this8.call.apply(_this8, [l].concat(S)) : _this8.nativeEl[l].apply(_this8.nativeEl, S);
          }();
        };else {
          var S = {
            get: function get() {
              var v, P, I;
              T(this, q, ce).call(this);
              var g = l.toLowerCase();

              if (p.has(g)) {
                var oe = this.getAttribute(g);
                return oe === null ? !1 : oe === "" ? !0 : oe;
              }

              return (I = (v = this.get) == null ? void 0 : v.call(this, l)) != null ? I : (P = this.nativeEl) == null ? void 0 : P[l];
            }
          };
          l !== l.toUpperCase() && (S.set = function (g) {
            T(this, q, ce).call(this);
            var v = l.toLowerCase();

            if (p.has(v)) {
              g === !0 || g === !1 || g == null ? this.toggleAttribute(v, Boolean(g)) : this.setAttribute(v, g);
              return;
            }

            if (this.set) {
              this.set(l, g);
              return;
            }

            this.nativeEl[l] = g;
          }), Object.defineProperty(_this7.prototype, l, S);
        }
      };

      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _ret = _loop();

        if (_ret === "continue") continue;
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }, ke = new WeakMap(), M = new WeakMap(), q = new WeakSet(), ce = function ce() {
    var _this9 = this;

    var k, S;
    if (r(this, ke)) return;

    if (c(this, ke, !0), !this.nativeEl) {
      var g = document.createElement(t, {
        is: e
      });
      g.part = t, this.shadowRoot.append(g);
    }

    this.nativeEl.muted = this.hasAttribute("muted");

    var _iterator2 = _createForOfIteratorHelper(a),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _g = _step2.value;
        T(this, Fe, Gt).call(this, _g);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    var p = new Map(),
        l = this.shadowRoot.querySelector("slot:not([name])");
    l == null || l.addEventListener("slotchange", function () {
      var g = new Map(p);
      l.assignedElements().filter(function (v) {
        return ["track", "source"].includes(v.localName);
      }).forEach(function (v) {
        var I, oe;
        g.delete(v);
        var P = p.get(v);
        P || (P = v.cloneNode(), p.set(v, P)), (oe = (I = _this9.nativeEl).append) == null || oe.call(I, P);
      }), g.forEach(function (v) {
        return v.remove();
      });
    });

    var _iterator3 = _createForOfIteratorHelper(this.constructor.Events),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var _g2 = _step3.value;
        (S = (k = this.shadowRoot).addEventListener) == null || S.call(k, _g2, function (v) {
          v.target === _this9.nativeEl && _this9.dispatchEvent(new CustomEvent(v.type, {
            detail: v.detail
          }));
        }, !0);
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }, Fe = new WeakSet(), Gt = function Gt(p) {
    if (Object.prototype.hasOwnProperty.call(this, p)) {
      var l = this[p];
      delete this[p], this[p] = l;
    }
  }, Ge = new WeakSet(), Ut = function Ut(p, l, k) {
    var S, g, v, P;
    ["id", "class"].includes(p) || (k === null ? (g = (S = this.nativeEl).removeAttribute) == null || g.call(S, p) : (P = (v = this.nativeEl).setAttribute) == null || P.call(v, p, k));
  }, d(_E, b), f(_E, "Events", pt), f(_E, "template", t.endsWith("audio") ? ft : mt), d(_E, y, void 0), _E;
};

function ai(i) {
  var t = [];

  for (var e = Object.getPrototypeOf(i); e && e !== HTMLElement.prototype; e = Object.getPrototypeOf(e)) {
    t.push.apply(t, _toConsumableArray(Object.getOwnPropertyNames(e)));
  }

  return t;
}

var Ni = globalThis.document ? ze(HTMLElement, {
  tag: "video"
}) : /*#__PURE__*/function () {
  function _class() {
    _classCallCheck(this, _class);
  }

  return _class;
}(),
    Vi = globalThis.document ? ze(HTMLElement, {
  tag: "audio"
}) : /*#__PURE__*/function () {
  function _class2() {
    _classCallCheck(this, _class2);
  }

  return _class2;
}();

var V = /*#__PURE__*/function (_Event) {
  _inherits(V, _Event);

  var _super6 = _createSuper(V);

  function V(e, n) {
    var _this10;

    _classCallCheck(this, V);

    _this10 = _super6.call(this, e);
    f(_assertThisInitialized(_this10), "track");
    _this10.track = n.track;
    return _this10;
  }

  return V;
}( /*#__PURE__*/_wrapNativeSuper(Event));

var gt = new WeakMap();

function o(i) {
  var t;
  return (t = gt.get(i)) != null ? t : oi(i, {});
}

function oi(i, t) {
  var e = gt.get(i);
  return e || gt.set(i, e = {}), Object.assign(e, t);
}

function Xe(i, t) {
  var e = i.videoTracks;
  o(t).media = i, o(t).renditionSet || (o(t).renditionSet = new Set());
  var n = o(e).trackSet;
  n.add(t);
  var a = n.size - 1;
  a in te.prototype || Object.defineProperty(te.prototype, a, {
    get: function get() {
      return _toConsumableArray(o(this).trackSet)[a];
    }
  }), queueMicrotask(function () {
    e.dispatchEvent(new V("addtrack", {
      track: t
    }));
  });
}

function Je(i) {
  var n;
  var t = (n = o(i).media) == null ? void 0 : n.videoTracks;
  if (!t) return;
  o(t).trackSet.delete(i), queueMicrotask(function () {
    t.dispatchEvent(new V("removetrack", {
      track: i
    }));
  });
}

function Bt(i) {
  var n;
  var t = (n = o(i).media.videoTracks) != null ? n : [],
      e = !1;

  var _iterator4 = _createForOfIteratorHelper(t),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var a = _step4.value;
      a !== i && (a.selected = !1, e = !0);
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  if (e) {
    if (o(t).changeRequested) return;
    o(t).changeRequested = !0, queueMicrotask(function () {
      delete o(t).changeRequested, t.dispatchEvent(new Event("change"));
    });
  }
}

var G,
    U,
    B,
    ee,
    Ie,
    te = /*#__PURE__*/function (_EventTarget) {
  _inherits(te, _EventTarget);

  var _super7 = _createSuper(te);

  function te() {
    var _this11;

    _classCallCheck(this, te);

    _this11 = _super7.call(this);
    d(_assertThisInitialized(_this11), ee);
    d(_assertThisInitialized(_this11), G, void 0);
    d(_assertThisInitialized(_this11), U, void 0);
    d(_assertThisInitialized(_this11), B, void 0);
    o(_assertThisInitialized(_this11)).trackSet = new Set();
    return _this11;
  }

  _createClass(te, [{
    key: Symbol.iterator,
    value: function value() {
      return r(this, ee, Ie).values();
    }
  }, {
    key: "length",
    get: function get() {
      return r(this, ee, Ie).size;
    }
  }, {
    key: "getTrackById",
    value: function getTrackById(e) {
      var n;
      return (n = _toConsumableArray(r(this, ee, Ie)).find(function (a) {
        return a.id === e;
      })) != null ? n : null;
    }
  }, {
    key: "selectedIndex",
    get: function get() {
      return _toConsumableArray(r(this, ee, Ie)).findIndex(function (e) {
        return e.selected;
      });
    }
  }, {
    key: "onaddtrack",
    get: function get() {
      return r(this, G);
    }
  }, {
    key: "onaddtrack",
    set: function set(e) {
      r(this, G) && (this.removeEventListener("addtrack", r(this, G)), c(this, G, void 0)), typeof e == "function" && (c(this, G, e), this.addEventListener("addtrack", e));
    }
  }, {
    key: "onremovetrack",
    get: function get() {
      return r(this, U);
    }
  }, {
    key: "onremovetrack",
    set: function set(e) {
      r(this, U) && (this.removeEventListener("removetrack", r(this, U)), c(this, U, void 0)), typeof e == "function" && (c(this, U, e), this.addEventListener("removetrack", e));
    }
  }, {
    key: "onchange",
    get: function get() {
      return r(this, B);
    }
  }, {
    key: "onchange",
    set: function set(e) {
      r(this, B) && (this.removeEventListener("change", r(this, B)), c(this, B, void 0)), typeof e == "function" && (c(this, B, e), this.addEventListener("change", e));
    }
  }]);

  return te;
}( /*#__PURE__*/_wrapNativeSuper(EventTarget));

G = new WeakMap(), U = new WeakMap(), B = new WeakMap(), ee = new WeakSet(), Ie = function Ie() {
  return o(this).trackSet;
};

var F = /*#__PURE__*/function (_Event2) {
  _inherits(F, _Event2);

  var _super8 = _createSuper(F);

  function F(e, n) {
    var _this12;

    _classCallCheck(this, F);

    _this12 = _super8.call(this, e);
    f(_assertThisInitialized(_this12), "rendition");
    _this12.rendition = n.rendition;
    return _this12;
  }

  return F;
}( /*#__PURE__*/_wrapNativeSuper(Event));

function Yt(i, t) {
  var e = o(i).media.videoRenditions;
  o(t).media = o(i).media, o(t).track = i;
  var n = o(i).renditionSet;
  n.add(t);
  var a = n.size - 1;
  a in ie.prototype || Object.defineProperty(ie.prototype, a, {
    get: function get() {
      return ue(this)[a];
    }
  }), queueMicrotask(function () {
    !i.selected || e.dispatchEvent(new F("addrendition", {
      rendition: t
    }));
  });
}

function jt(i) {
  var t = o(i).media.videoRenditions,
      e = o(i).track;
  o(e).renditionSet.delete(i), queueMicrotask(function () {
    !o(i).track.selected || t.dispatchEvent(new F("removerendition", {
      rendition: i
    }));
  });
}

function Ht(i) {
  var t = o(i).media.videoRenditions;
  !t || o(t).changeRequested || (o(t).changeRequested = !0, queueMicrotask(function () {
    delete o(t).changeRequested, o(i).track.selected && t.dispatchEvent(new Event("change"));
  }));
}

function ue(i) {
  return _toConsumableArray(o(i).media.videoTracks).filter(function (e) {
    return e.selected;
  }).flatMap(function (e) {
    return _toConsumableArray(o(e).renditionSet);
  });
}

var Y,
    j,
    H,
    ie = /*#__PURE__*/function (_EventTarget2) {
  _inherits(ie, _EventTarget2);

  var _super9 = _createSuper(ie);

  function ie() {
    var _this13;

    _classCallCheck(this, ie);

    _this13 = _super9.apply(this, arguments);
    d(_assertThisInitialized(_this13), Y, void 0);
    d(_assertThisInitialized(_this13), j, void 0);
    d(_assertThisInitialized(_this13), H, void 0);
    return _this13;
  }

  _createClass(ie, [{
    key: Symbol.iterator,
    value: function value() {
      return ue(this).values();
    }
  }, {
    key: "length",
    get: function get() {
      return ue(this).length;
    }
  }, {
    key: "getRenditionById",
    value: function getRenditionById(e) {
      var n;
      return (n = ue(this).find(function (a) {
        return "".concat(a.id) == "".concat(e);
      })) != null ? n : null;
    }
  }, {
    key: "selectedIndex",
    get: function get() {
      return ue(this).findIndex(function (e) {
        return e.selected;
      });
    }
  }, {
    key: "selectedIndex",
    set: function set(e) {
      var _iterator5 = _createForOfIteratorHelper(ue(this).entries()),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _step5$value = _slicedToArray(_step5.value, 2),
              n = _step5$value[0],
              a = _step5$value[1];

          a.selected = n === e;
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  }, {
    key: "onaddrendition",
    get: function get() {
      return r(this, Y);
    }
  }, {
    key: "onaddrendition",
    set: function set(e) {
      r(this, Y) && (this.removeEventListener("addrendition", r(this, Y)), c(this, Y, void 0)), typeof e == "function" && (c(this, Y, e), this.addEventListener("addrendition", e));
    }
  }, {
    key: "onremoverendition",
    get: function get() {
      return r(this, j);
    }
  }, {
    key: "onremoverendition",
    set: function set(e) {
      r(this, j) && (this.removeEventListener("removerendition", r(this, j)), c(this, j, void 0)), typeof e == "function" && (c(this, j, e), this.addEventListener("removerendition", e));
    }
  }, {
    key: "onchange",
    get: function get() {
      return r(this, H);
    }
  }, {
    key: "onchange",
    set: function set(e) {
      r(this, H) && (this.removeEventListener("change", r(this, H)), c(this, H, void 0)), typeof e == "function" && (c(this, H, e), this.addEventListener("change", e));
    }
  }]);

  return ie;
}( /*#__PURE__*/_wrapNativeSuper(EventTarget));

Y = new WeakMap(), j = new WeakMap(), H = new WeakMap();

var he,
    we = /*#__PURE__*/function () {
  function we() {
    _classCallCheck(this, we);

    f(this, "src");
    f(this, "id");
    f(this, "width");
    f(this, "height");
    f(this, "bitrate");
    f(this, "frameRate");
    f(this, "codec");
    d(this, he, !1);
  }

  _createClass(we, [{
    key: "selected",
    get: function get() {
      return r(this, he);
    },
    set: function set(t) {
      r(this, he) !== t && (c(this, he, t), Ht(this));
    }
  }]);

  return we;
}();

he = new WeakMap();

var le,
    fe = /*#__PURE__*/function () {
  function fe() {
    _classCallCheck(this, fe);

    f(this, "id");
    f(this, "kind");
    f(this, "label", "");
    f(this, "language", "");
    f(this, "sourceBuffer");
    d(this, le, !1);
  }

  _createClass(fe, [{
    key: "addRendition",
    value: function addRendition(t, e, n, a, m, E) {
      var y = new we();
      return y.src = t, y.width = e, y.height = n, y.frameRate = E, y.bitrate = m, y.codec = a, Yt(this, y), y;
    }
  }, {
    key: "removeRendition",
    value: function removeRendition(t) {
      jt(t);
    }
  }, {
    key: "selected",
    get: function get() {
      return r(this, le);
    },
    set: function set(t) {
      r(this, le) !== t && (c(this, le, t), t === !0 && Bt(this));
    }
  }]);

  return fe;
}();

le = new WeakMap();

function Wt(i, t) {
  var e = o(i).media.audioRenditions;
  o(t).media = o(i).media, o(t).track = i;
  var n = o(i).renditionSet;
  n.add(t);
  var a = n.size - 1;
  a in re.prototype || Object.defineProperty(re.prototype, a, {
    get: function get() {
      return me(this)[a];
    }
  }), queueMicrotask(function () {
    !i.enabled || e.dispatchEvent(new F("addrendition", {
      rendition: t
    }));
  });
}

function Kt(i) {
  var t = o(i).media.audioRenditions,
      e = o(i).track;
  o(e).renditionSet.delete(i), queueMicrotask(function () {
    !o(i).track.enabled || t.dispatchEvent(new F("removerendition", {
      rendition: i
    }));
  });
}

function $t(i) {
  var t = o(i).media.audioRenditions;
  !t || o(t).changeRequested || (o(t).changeRequested = !0, queueMicrotask(function () {
    delete o(t).changeRequested, o(i).track.enabled && t.dispatchEvent(new Event("change"));
  }));
}

function me(i) {
  return _toConsumableArray(o(i).media.audioTracks).filter(function (e) {
    return e.enabled;
  }).flatMap(function (e) {
    return _toConsumableArray(o(e).renditionSet);
  });
}

var W,
    K,
    $,
    re = /*#__PURE__*/function (_EventTarget3) {
  _inherits(re, _EventTarget3);

  var _super10 = _createSuper(re);

  function re() {
    var _this14;

    _classCallCheck(this, re);

    _this14 = _super10.apply(this, arguments);
    d(_assertThisInitialized(_this14), W, void 0);
    d(_assertThisInitialized(_this14), K, void 0);
    d(_assertThisInitialized(_this14), $, void 0);
    return _this14;
  }

  _createClass(re, [{
    key: Symbol.iterator,
    value: function value() {
      return me(this).values();
    }
  }, {
    key: "length",
    get: function get() {
      return me(this).length;
    }
  }, {
    key: "getRenditionById",
    value: function getRenditionById(e) {
      var n;
      return (n = me(this).find(function (a) {
        return "".concat(a.id) == "".concat(e);
      })) != null ? n : null;
    }
  }, {
    key: "selectedIndex",
    get: function get() {
      return me(this).findIndex(function (e) {
        return e.selected;
      });
    }
  }, {
    key: "selectedIndex",
    set: function set(e) {
      var _iterator6 = _createForOfIteratorHelper(me(this).entries()),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var _step6$value = _slicedToArray(_step6.value, 2),
              n = _step6$value[0],
              a = _step6$value[1];

          a.selected = n === e;
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }
  }, {
    key: "onaddrendition",
    get: function get() {
      return r(this, W);
    }
  }, {
    key: "onaddrendition",
    set: function set(e) {
      r(this, W) && (this.removeEventListener("addrendition", r(this, W)), c(this, W, void 0)), typeof e == "function" && (c(this, W, e), this.addEventListener("addrendition", e));
    }
  }, {
    key: "onremoverendition",
    get: function get() {
      return r(this, K);
    }
  }, {
    key: "onremoverendition",
    set: function set(e) {
      r(this, K) && (this.removeEventListener("removerendition", r(this, K)), c(this, K, void 0)), typeof e == "function" && (c(this, K, e), this.addEventListener("removerendition", e));
    }
  }, {
    key: "onchange",
    get: function get() {
      return r(this, $);
    }
  }, {
    key: "onchange",
    set: function set(e) {
      r(this, $) && (this.removeEventListener("change", r(this, $)), c(this, $, void 0)), typeof e == "function" && (c(this, $, e), this.addEventListener("change", e));
    }
  }]);

  return re;
}( /*#__PURE__*/_wrapNativeSuper(EventTarget));

W = new WeakMap(), K = new WeakMap(), $ = new WeakMap();

var pe,
    Me = /*#__PURE__*/function () {
  function Me() {
    _classCallCheck(this, Me);

    f(this, "src");
    f(this, "id");
    f(this, "bitrate");
    f(this, "codec");
    d(this, pe, !1);
  }

  _createClass(Me, [{
    key: "selected",
    get: function get() {
      return r(this, pe);
    },
    set: function set(t) {
      r(this, pe) !== t && (c(this, pe, t), $t(this));
    }
  }]);

  return Me;
}();

pe = new WeakMap();

function Ze(i, t) {
  var e = i.audioTracks;
  o(t).media = i, o(t).renditionSet || (o(t).renditionSet = new Set());
  var n = o(e).trackSet;
  n.add(t);
  var a = n.size - 1;
  a in se.prototype || Object.defineProperty(se.prototype, a, {
    get: function get() {
      return _toConsumableArray(o(this).trackSet)[a];
    }
  }), queueMicrotask(function () {
    e.dispatchEvent(new V("addtrack", {
      track: t
    }));
  });
}

function et(i) {
  var n;
  var t = (n = o(i).media) == null ? void 0 : n.audioTracks;
  if (!t) return;
  o(t).trackSet.delete(i), queueMicrotask(function () {
    t.dispatchEvent(new V("removetrack", {
      track: i
    }));
  });
}

function zt(i) {
  var t = o(i).media.audioTracks;
  !t || o(t).changeRequested || (o(t).changeRequested = !0, queueMicrotask(function () {
    delete o(t).changeRequested, t.dispatchEvent(new Event("change"));
  }));
}

var z,
    X,
    J,
    ge,
    Qe,
    se = /*#__PURE__*/function (_EventTarget4) {
  _inherits(se, _EventTarget4);

  var _super11 = _createSuper(se);

  function se() {
    var _this15;

    _classCallCheck(this, se);

    _this15 = _super11.call(this);
    d(_assertThisInitialized(_this15), ge);
    d(_assertThisInitialized(_this15), z, void 0);
    d(_assertThisInitialized(_this15), X, void 0);
    d(_assertThisInitialized(_this15), J, void 0);
    o(_assertThisInitialized(_this15)).trackSet = new Set();
    return _this15;
  }

  _createClass(se, [{
    key: Symbol.iterator,
    value: function value() {
      return r(this, ge, Qe).values();
    }
  }, {
    key: "length",
    get: function get() {
      return r(this, ge, Qe).size;
    }
  }, {
    key: "getTrackById",
    value: function getTrackById(e) {
      var n;
      return (n = _toConsumableArray(r(this, ge, Qe)).find(function (a) {
        return a.id === e;
      })) != null ? n : null;
    }
  }, {
    key: "onaddtrack",
    get: function get() {
      return r(this, z);
    }
  }, {
    key: "onaddtrack",
    set: function set(e) {
      r(this, z) && (this.removeEventListener("addtrack", r(this, z)), c(this, z, void 0)), typeof e == "function" && (c(this, z, e), this.addEventListener("addtrack", e));
    }
  }, {
    key: "onremovetrack",
    get: function get() {
      return r(this, X);
    }
  }, {
    key: "onremovetrack",
    set: function set(e) {
      r(this, X) && (this.removeEventListener("removetrack", r(this, X)), c(this, X, void 0)), typeof e == "function" && (c(this, X, e), this.addEventListener("removetrack", e));
    }
  }, {
    key: "onchange",
    get: function get() {
      return r(this, J);
    }
  }, {
    key: "onchange",
    set: function set(e) {
      r(this, J) && (this.removeEventListener("change", r(this, J)), c(this, J, void 0)), typeof e == "function" && (c(this, J, e), this.addEventListener("change", e));
    }
  }]);

  return se;
}( /*#__PURE__*/_wrapNativeSuper(EventTarget));

z = new WeakMap(), X = new WeakMap(), J = new WeakMap(), ge = new WeakSet(), Qe = function Qe() {
  return o(this).trackSet;
};

var Ee,
    ve = /*#__PURE__*/function () {
  function ve() {
    _classCallCheck(this, ve);

    f(this, "id");
    f(this, "kind");
    f(this, "label", "");
    f(this, "language", "");
    f(this, "sourceBuffer");
    d(this, Ee, !1);
  }

  _createClass(ve, [{
    key: "addRendition",
    value: function addRendition(t, e, n) {
      var a = new Me();
      return a.src = t, a.codec = e, a.bitrate = n, Wt(this, a), a;
    }
  }, {
    key: "removeRendition",
    value: function removeRendition(t) {
      Kt(t);
    }
  }, {
    key: "enabled",
    get: function get() {
      return r(this, Ee);
    },
    set: function set(t) {
      r(this, Ee) !== t && (c(this, Ee, t), zt(this));
    }
  }]);

  return ve;
}();

Ee = new WeakMap();
var Xt = tt(globalThis.HTMLMediaElement, "video"),
    Jt = tt(globalThis.HTMLMediaElement, "audio");

function Qt(i) {
  if (!(i != null && i.prototype)) return i;
  var t = tt(i, "video");
  (!t || "".concat(t).includes("[native code]")) && Object.defineProperty(i.prototype, "videoTracks", {
    get: function get() {
      return di(this);
    }
  });
  var e = tt(i, "audio");
  (!e || "".concat(e).includes("[native code]")) && Object.defineProperty(i.prototype, "audioTracks", {
    get: function get() {
      return ci(this);
    }
  }), "addVideoTrack" in i.prototype || (i.prototype.addVideoTrack = function (m) {
    var E = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var y = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    var b = new fe();
    return b.kind = m, b.label = E, b.language = y, Xe(this, b), b;
  }), "removeVideoTrack" in i.prototype || (i.prototype.removeVideoTrack = Je), "addAudioTrack" in i.prototype || (i.prototype.addAudioTrack = function (m) {
    var E = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
    var y = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
    var b = new ve();
    return b.kind = m, b.label = E, b.language = y, Ze(this, b), b;
  }), "removeAudioTrack" in i.prototype || (i.prototype.removeAudioTrack = et), "videoRenditions" in i.prototype || Object.defineProperty(i.prototype, "videoRenditions", {
    get: function get() {
      return n(this);
    }
  });

  var n = function n(m) {
    var E = o(m).videoRenditions;
    return E || (E = new ie(), o(E).media = m, o(m).videoRenditions = E), E;
  };

  "audioRenditions" in i.prototype || Object.defineProperty(i.prototype, "audioRenditions", {
    get: function get() {
      return a(this);
    }
  });

  var a = function a(m) {
    var E = o(m).audioRenditions;
    return E || (E = new re(), o(E).media = m, o(m).audioRenditions = E), E;
  };

  return i;
}

function tt(i, t) {
  var e;
  if (i != null && i.prototype) return (e = Object.getOwnPropertyDescriptor(i.prototype, "".concat(t, "Tracks"))) == null ? void 0 : e.get;
}

function di(i) {
  var e;
  var t = o(i).videoTracks;

  if (!t && (t = new te(), o(i).videoTracks = t, Xt)) {
    var n = Xt.call((e = i.nativeEl) != null ? e : i);

    var _iterator7 = _createForOfIteratorHelper(n),
        _step7;

    try {
      for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
        var a = _step7.value;
        Xe(i, a);
      }
    } catch (err) {
      _iterator7.e(err);
    } finally {
      _iterator7.f();
    }

    n.addEventListener("change", function () {
      t.dispatchEvent(new Event("change"));
    }), n.addEventListener("addtrack", function (a) {
      if (_toConsumableArray(t).some(function (m) {
        return m instanceof fe;
      })) {
        var _iterator8 = _createForOfIteratorHelper(n),
            _step8;

        try {
          for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
            var m = _step8.value;
            Je(m);
          }
        } catch (err) {
          _iterator8.e(err);
        } finally {
          _iterator8.f();
        }

        return;
      }

      Xe(i, a.track);
    }), n.addEventListener("removetrack", function (a) {
      Je(a.track);
    });
  }

  return t;
}

function ci(i) {
  var e;
  var t = o(i).audioTracks;

  if (!t && (t = new se(), o(i).audioTracks = t, Jt)) {
    var n = Jt.call((e = i.nativeEl) != null ? e : i);

    var _iterator9 = _createForOfIteratorHelper(n),
        _step9;

    try {
      for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
        var a = _step9.value;
        Ze(i, a);
      }
    } catch (err) {
      _iterator9.e(err);
    } finally {
      _iterator9.f();
    }

    n.addEventListener("change", function () {
      t.dispatchEvent(new Event("change"));
    }), n.addEventListener("addtrack", function (a) {
      if (_toConsumableArray(t).some(function (m) {
        return m instanceof ve;
      })) {
        var _iterator10 = _createForOfIteratorHelper(n),
            _step10;

        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var m = _step10.value;
            et(m);
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }

        return;
      }

      Ze(i, a.track);
    }), n.addEventListener("removetrack", function (a) {
      et(a.track);
    });
  }

  return t;
}

pt.push("castchange", "entercast", "leavecast");

var Et = Qt(ze(Oe.HTMLElement, {
  tag: "video",
  is: "castable-video"
})),
    u = {
  BEACON_COLLECTION_DOMAIN: "beacon-collection-domain",
  CUSTOM_DOMAIN: "custom-domain",
  DEBUG: "debug",
  DISABLE_COOKIES: "disable-cookies",
  ENV_KEY: "env-key",
  MAX_RESOLUTION: "max-resolution",
  MIN_RESOLUTION: "min-resolution",
  RENDITION_ORDER: "rendition-order",
  METADATA_URL: "metadata-url",
  PLAYBACK_ID: "playback-id",
  PLAYER_SOFTWARE_NAME: "player-software-name",
  PLAYER_SOFTWARE_VERSION: "player-software-version",
  PREFER_CMCD: "prefer-cmcd",
  PREFER_PLAYBACK: "prefer-playback",
  START_TIME: "start-time",
  STREAM_TYPE: "stream-type",
  TARGET_LIVE_WINDOW: "target-live-window",
  LIVE_EDGE_OFFSET: "live-edge-offset",
  TYPE: "type"
},
    Ri = Object.values(u),
    Pi = Ct(),
    Li = "mux-video",
    _,
    ye,
    _e,
    Te,
    De,
    Ne,
    Ve,
    be,
    rt,
    xe = /*#__PURE__*/function (_Et) {
  _inherits(xe, _Et);

  var _super12 = _createSuper(xe);

  function xe() {
    var _this16;

    _classCallCheck(this, xe);

    _this16 = _super12.call(this);
    d(_assertThisInitialized(_this16), be);
    d(_assertThisInitialized(_this16), _, void 0);
    d(_assertThisInitialized(_this16), ye, void 0);
    d(_assertThisInitialized(_this16), _e, void 0);
    d(_assertThisInitialized(_this16), Te, {});
    d(_assertThisInitialized(_this16), De, void 0);
    d(_assertThisInitialized(_this16), Ne, void 0);
    d(_assertThisInitialized(_this16), Ve, void 0);
    c(_assertThisInitialized(_this16), _e, li());
    return _this16;
  }

  _createClass(xe, [{
    key: "preferCmcd",
    get: function get() {
      var e;
      return (e = this.getAttribute(u.PREFER_CMCD)) != null ? e : void 0;
    },
    set: function set(e) {
      e !== this.preferCmcd && (e ? Zt.includes(e) ? this.setAttribute(u.PREFER_CMCD, e) : console.warn("Invalid value for preferCmcd. Must be one of ".concat(Zt.join())) : this.removeAttribute(u.PREFER_CMCD));
    }
  }, {
    key: "playerInitTime",
    get: function get() {
      return r(this, _e);
    }
  }, {
    key: "playerSoftwareName",
    get: function get() {
      var e;
      return (e = r(this, Ne)) != null ? e : Li;
    },
    set: function set(e) {
      c(this, Ne, e);
    }
  }, {
    key: "playerSoftwareVersion",
    get: function get() {
      var e;
      return (e = r(this, De)) != null ? e : Pi;
    },
    set: function set(e) {
      c(this, De, e);
    }
  }, {
    key: "_hls",
    get: function get() {
      var e;
      return (e = r(this, _)) == null ? void 0 : e.engine;
    }
  }, {
    key: "mux",
    get: function get() {
      var e;
      return (e = this.nativeEl) == null ? void 0 : e.mux;
    }
  }, {
    key: "error",
    get: function get() {
      var e;
      return (e = mi(this.nativeEl)) != null ? e : null;
    }
  }, {
    key: "errorTranslator",
    get: function get() {
      return r(this, Ve);
    },
    set: function set(e) {
      c(this, Ve, e);
    }
  }, {
    key: "src",
    get: function get() {
      return this.getAttribute("src");
    },
    set: function set(e) {
      e !== this.src && (e == null ? this.removeAttribute("src") : this.setAttribute("src", e));
    }
  }, {
    key: "type",
    get: function get() {
      var e;
      return (e = this.getAttribute(u.TYPE)) != null ? e : void 0;
    },
    set: function set(e) {
      e !== this.type && (e ? this.setAttribute(u.TYPE, e) : this.removeAttribute(u.TYPE));
    }
  }, {
    key: "autoplay",
    get: function get() {
      var e = this.getAttribute("autoplay");
      return e === null ? !1 : e === "" ? !0 : e;
    },
    set: function set(e) {
      var n = this.autoplay;
      e !== n && (e ? this.setAttribute("autoplay", typeof e == "string" ? e : "") : this.removeAttribute("autoplay"));
    }
  }, {
    key: "preload",
    get: function get() {
      var e = this.getAttribute("preload");
      return e === "" ? "auto" : ["none", "metadata", "auto"].includes(e) ? e : _get(_getPrototypeOf(xe.prototype), "preload", this);
    },
    set: function set(e) {
      e != this.getAttribute("preload") && (["", "none", "metadata", "auto"].includes(e) ? this.setAttribute("preload", e) : this.removeAttribute("preload"));
    }
  }, {
    key: "debug",
    get: function get() {
      return this.getAttribute(u.DEBUG) != null;
    },
    set: function set(e) {
      e !== this.debug && (e ? this.setAttribute(u.DEBUG, "") : this.removeAttribute(u.DEBUG));
    }
  }, {
    key: "disableCookies",
    get: function get() {
      return this.hasAttribute(u.DISABLE_COOKIES);
    },
    set: function set(e) {
      e !== this.disableCookies && (e ? this.setAttribute(u.DISABLE_COOKIES, "") : this.removeAttribute(u.DISABLE_COOKIES));
    }
  }, {
    key: "startTime",
    get: function get() {
      var e = this.getAttribute(u.START_TIME);
      if (e == null) return;
      var n = +e;
      return Number.isNaN(n) ? void 0 : n;
    },
    set: function set(e) {
      e !== this.startTime && (e == null ? this.removeAttribute(u.START_TIME) : this.setAttribute(u.START_TIME, "".concat(e)));
    }
  }, {
    key: "playbackId",
    get: function get() {
      var e;
      return (e = this.getAttribute(u.PLAYBACK_ID)) != null ? e : void 0;
    },
    set: function set(e) {
      e !== this.playbackId && (e ? this.setAttribute(u.PLAYBACK_ID, e) : this.removeAttribute(u.PLAYBACK_ID));
    }
  }, {
    key: "maxResolution",
    get: function get() {
      var e;
      return (e = this.getAttribute(u.MAX_RESOLUTION)) != null ? e : void 0;
    },
    set: function set(e) {
      e !== this.maxResolution && (e ? this.setAttribute(u.MAX_RESOLUTION, e) : this.removeAttribute(u.MAX_RESOLUTION));
    }
  }, {
    key: "minResolution",
    get: function get() {
      var e;
      return (e = this.getAttribute(u.MIN_RESOLUTION)) != null ? e : void 0;
    },
    set: function set(e) {
      e !== this.minResolution && (e ? this.setAttribute(u.MIN_RESOLUTION, e) : this.removeAttribute(u.MIN_RESOLUTION));
    }
  }, {
    key: "renditionOrder",
    get: function get() {
      var e;
      return (e = this.getAttribute(u.RENDITION_ORDER)) != null ? e : void 0;
    },
    set: function set(e) {
      e !== this.renditionOrder && (e ? this.setAttribute(u.RENDITION_ORDER, e) : this.removeAttribute(u.RENDITION_ORDER));
    }
  }, {
    key: "customDomain",
    get: function get() {
      var e;
      return (e = this.getAttribute(u.CUSTOM_DOMAIN)) != null ? e : void 0;
    },
    set: function set(e) {
      e !== this.customDomain && (e ? this.setAttribute(u.CUSTOM_DOMAIN, e) : this.removeAttribute(u.CUSTOM_DOMAIN));
    }
  }, {
    key: "ended",
    get: function get() {
      return Si(this.nativeEl, this._hls);
    }
  }, {
    key: "envKey",
    get: function get() {
      var e;
      return (e = this.getAttribute(u.ENV_KEY)) != null ? e : void 0;
    },
    set: function set(e) {
      e !== this.envKey && (e ? this.setAttribute(u.ENV_KEY, e) : this.removeAttribute(u.ENV_KEY));
    }
  }, {
    key: "beaconCollectionDomain",
    get: function get() {
      var e;
      return (e = this.getAttribute(u.BEACON_COLLECTION_DOMAIN)) != null ? e : void 0;
    },
    set: function set(e) {
      e !== this.beaconCollectionDomain && (e ? this.setAttribute(u.BEACON_COLLECTION_DOMAIN, e) : this.removeAttribute(u.BEACON_COLLECTION_DOMAIN));
    }
  }, {
    key: "streamType",
    get: function get() {
      var e;
      return (e = this.getAttribute(u.STREAM_TYPE)) != null ? e : Ti(this.nativeEl);
    },
    set: function set(e) {
      e !== this.streamType && (e ? this.setAttribute(u.STREAM_TYPE, e) : this.removeAttribute(u.STREAM_TYPE));
    }
  }, {
    key: "targetLiveWindow",
    get: function get() {
      return this.hasAttribute(u.TARGET_LIVE_WINDOW) ? +this.getAttribute(u.TARGET_LIVE_WINDOW) : bi(this.nativeEl);
    },
    set: function set(e) {
      e != this.targetLiveWindow && (e == null ? this.removeAttribute(u.TARGET_LIVE_WINDOW) : this.setAttribute(u.TARGET_LIVE_WINDOW, "".concat(+e)));
    }
  }, {
    key: "liveEdgeStart",
    get: function get() {
      var e, n;

      if (this.hasAttribute(u.LIVE_EDGE_OFFSET)) {
        var a = this.liveEdgeOffset,
            m = (e = this.nativeEl.seekable.end(0)) != null ? e : 0,
            E = (n = this.nativeEl.seekable.start(0)) != null ? n : 0;
        return Math.max(E, m - a);
      }

      return ki(this.nativeEl);
    }
  }, {
    key: "liveEdgeOffset",
    get: function get() {
      if (!!this.hasAttribute(u.LIVE_EDGE_OFFSET)) return +this.getAttribute(u.LIVE_EDGE_OFFSET);
    },
    set: function set(e) {
      e != this.targetLiveWindow && (e == null ? this.removeAttribute(u.LIVE_EDGE_OFFSET) : this.setAttribute(u.LIVE_EDGE_OFFSET, "".concat(+e)));
    }
  }, {
    key: "seekable",
    get: function get() {
      return Ai(this.nativeEl);
    }
  }, {
    key: "addCuePoints",
    value: function () {
      var _addCuePoints = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(e) {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt("return", pi(this.nativeEl, e));

              case 1:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function addCuePoints(_x) {
        return _addCuePoints.apply(this, arguments);
      }

      return addCuePoints;
    }()
  }, {
    key: "activeCuePoint",
    get: function get() {
      return Ei(this.nativeEl);
    }
  }, {
    key: "cuePoints",
    get: function get() {
      return gi(this.nativeEl);
    }
  }, {
    key: "getStartDate",
    value: function getStartDate() {
      return vi(this.nativeEl, this._hls);
    }
  }, {
    key: "currentPdt",
    get: function get() {
      return yi(this.nativeEl, this._hls);
    }
  }, {
    key: "preferPlayback",
    get: function get() {
      var e = this.getAttribute(u.PREFER_PLAYBACK);
      if (e === it.MSE || e === it.NATIVE) return e;
    },
    set: function set(e) {
      e !== this.preferPlayback && (e === it.MSE || e === it.NATIVE ? this.setAttribute(u.PREFER_PLAYBACK, e) : this.removeAttribute(u.PREFER_PLAYBACK));
    }
  }, {
    key: "metadata",
    get: function get() {
      var _this17 = this;

      return _objectSpread(_objectSpread({}, this.getAttributeNames().filter(function (n) {
        return n.startsWith("metadata-") && ![u.METADATA_URL].includes(n);
      }).reduce(function (n, a) {
        var m = _this17.getAttribute(a);

        return m != null && (n[a.replace(/^metadata-/, "").replace(/-/g, "_")] = m), n;
      }, {})), r(this, Te));
    },
    set: function set(e) {
      c(this, Te, e != null ? e : {}), this.mux && this.mux.emit("hb", r(this, Te));
    }
  }, {
    key: "load",
    value: function load() {
      c(this, _, ui(this, this.nativeEl, r(this, _)));
    }
  }, {
    key: "unload",
    value: function unload() {
      hi(this.nativeEl, r(this, _)), c(this, _, void 0);
    }
  }, {
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(e, n, a) {
      var _this18 = this;

      var E, y;

      switch (Et.observedAttributes.includes(e) && !["src", "autoplay", "preload"].includes(e) && _get(_getPrototypeOf(xe.prototype), "attributeChangedCallback", this).call(this, e, n, a), e) {
        case u.PLAYER_SOFTWARE_NAME:
          this.playerSoftwareName = a != null ? a : void 0;
          break;

        case u.PLAYER_SOFTWARE_VERSION:
          this.playerSoftwareVersion = a != null ? a : void 0;
          break;

        case "src":
          {
            var b = !!n,
                L = !!a;
            !b && L ? T(this, be, rt).call(this) : b && !L ? this.unload() : b && L && (this.unload(), T(this, be, rt).call(this));
            break;
          }

        case "autoplay":
          if (a === n) break;
          (E = r(this, _)) == null || E.setAutoplay(this.autoplay);
          break;

        case "preload":
          if (a === n) break;
          (y = r(this, _)) == null || y.setPreload(a);
          break;

        case u.PLAYBACK_ID:
          this.src = fi(this);
          break;

        case u.DEBUG:
          {
            var _b = this.debug;
            this.mux && console.info("Cannot toggle debug mode of mux data after initialization. Make sure you set all metadata to override before setting the src."), this._hls && (this._hls.config.debug = _b);
            break;
          }

        case u.METADATA_URL:
          a && fetch(a).then(function (b) {
            return b.json();
          }).then(function (b) {
            return _this18.metadata = b;
          }).catch(function () {
            return console.error("Unable to load or parse metadata JSON from metadata-url ".concat(a, "!"));
          });
          break;

        case u.STREAM_TYPE:
          (a == null || a !== n) && this.dispatchEvent(new CustomEvent("streamtypechange", {
            composed: !0,
            bubbles: !0
          }));
          break;

        case u.TARGET_LIVE_WINDOW:
          (a == null || a !== n) && this.dispatchEvent(new CustomEvent("targetlivewindowchange", {
            composed: !0,
            bubbles: !0,
            detail: this.targetLiveWindow
          }));
          break;

        default:
          break;
      }
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var e;
      (e = _get(_getPrototypeOf(xe.prototype), "connectedCallback", this)) == null || e.call(this), this.nativeEl && this.src && !r(this, _) && T(this, be, rt).call(this);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.unload();
    }
  }], [{
    key: "observedAttributes",
    get: function get() {
      var e;
      return [].concat(_toConsumableArray(Ri), _toConsumableArray((e = Et.observedAttributes) != null ? e : []));
    }
  }]);

  return xe;
}(Et);

_ = new WeakMap(), ye = new WeakMap(), _e = new WeakMap(), Te = new WeakMap(), De = new WeakMap(), Ne = new WeakMap(), Ve = new WeakMap(), be = new WeakSet(), rt = /*#__PURE__*/function () {
  var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.t0 = r(this, ye);

            if (_context8.t0) {
              _context8.next = 6;
              break;
            }

            _context8.next = 4;
            return c(this, ye, Promise.resolve());

          case 4:
            c(this, ye, null);
            this.load();

          case 6:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, this);
  }));

  return function rt() {
    return _ref20.apply(this, arguments);
  };
}();
Oe.customElements.get("mux-video") || (Oe.customElements.define("mux-video", xe), Oe.MuxVideoElement = xe);
var is = xe;
export { u as Attributes, Xr as MediaError, pt as VideoEvents, is as default };